// extracted by mini-css-extract-plugin
export default {"container":"Tj-z","blurb":"Uj-z","links":"Vj-z"};